import React from "react";
import MyLabel from "./MyLabel";

const MyInputRHF = ({
  title,
  name,
  type = "text",
  placeholder,
  register,
  errors,
  required = false,
  disabled = false,
  className = "",
  min,
  max,
}) => {
  console.log("er", errors);

  return (
    <div className="form-group">
      {/* Label */}
      {title && <MyLabel title={title} name={name} required={required} />}

      {/* Input */}
      <input
        type={type}
        placeholder={placeholder}
        disabled={disabled}
        className={`form-control ${errors?.[name] ? "is-invalid" : ""} ${className}`}
        {...register(name, {
          required: required ? `Please enter ${title}` : false,
          min: { value: min, message: "Minimum tax will be 0" },
          max: { value: max, message: "Maximum tax will be 100 " },
        })}
      />

      {/* Error Message */}
      {errors?.[name] && (
        <span
          style={{
            color: "#e85347",
            fontSize: "11px",
            fontStyle: "italic",
          }}
        >
          {errors[name].message}
        </span>
      )}
    </div>
  );
};

export default MyInputRHF;
